export default __webpack_public_path__ + "static/media/whitev3.dd972757.svg";